import React from 'react';
import { Box } from '@mui/material';

import LegendItem from './LegendItem';

const Legend = ({ labelMapping, colorMapping, inline = false }) => (
  <Box
    sx={{
      display       : 'flex',
      flexWrap      : 'wrap',
      flexDirection : inline ? 'row' : 'column',
      gap           : '10px 20px',
    }}>
    {Object.entries(labelMapping).map(([key, value]) => (
      <LegendItem
        key={key}
        label={value}
        color={colorMapping[key].background}
      />
    ))}
  </Box>
);

export default Legend;
